import get from 'lodash-es/get'
import isArray from 'lodash-es/isArray'
import isObject from 'lodash-es/isObject'

import { useRoles } from '@fourthwall/auth'
import type { Paths } from '@fourthwall/types/dist/string'

import type { DashboardPermissions } from './types'
import { useDashboardPermissionsContext } from './useDashboardPermissionsContext'

export const useDashboardPermissions = () => {
  const { dashboardPermissions } = useDashboardPermissionsContext()
  const { hasRole, hasGroup } = useRoles()

  const hasSinglePermission = (permissionKey: Paths<DashboardPermissions>): boolean => {
    const permission = get(dashboardPermissions, permissionKey)

    if (isObject(permission)) {
      return Object.keys(permission).some((key) =>
        hasSinglePermission(`${permissionKey}.${key}` as Paths<DashboardPermissions>),
      )
    }

    return permission
  }

  const hasPermission = (
    permissionKey: Paths<DashboardPermissions> | Paths<DashboardPermissions>[],
  ): boolean => {
    if (isArray(permissionKey)) {
      return permissionKey.every((key) => hasSinglePermission(key))
    }

    return hasSinglePermission(permissionKey)
  }

  const hasAnyPermission = () => {
    return Object.keys(dashboardPermissions).some((key) =>
      hasPermission(key as Paths<DashboardPermissions>),
    )
  }

  return {
    dashboardPermissions,
    hasPermission,
    hasAnyPermission,
    hasRole,
    hasGroup,
  }
}
